import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { AdminSection } from '@typings';
import { PATH } from '@constants';
import { userSelector } from '@selectors';
import { useSelector } from '@hooks';

import AdminSectionLayout from '@components/Layouts/AdminSectionLayout';

import { withSuspense } from './utils';

const AdminSectionClusterDetailsLayout = lazy(
  () => import('@components/Layouts/AdminSectionClusterDetailsLayout'),
);

const AdminSectionUsersPage = lazy(
  () => import('@pages/AdminSection/AdminSectionUsersPage'),
);
const AdminSectionClustersPage = lazy(
  () => import('@pages/AdminSection/AdminSectionClustersPage'),
);
const AdminSectionOrganizationsPage = lazy(
  () => import('@pages/AdminSection/AdminSectionOrganizationsPage'),
);

const AdminSectionClusterNodesPage = lazy(
  () => import('@pages/AdminSection/AdminSectionClusterNodesPage'),
);
const AdminSectionClusterResourcesPage = lazy(
  () => import('@pages/AdminSection/AdminSectionClusterResourcesPage'),
);
const AdminSectionClusterReportsPage = lazy(
  () => import('@pages/AdminSection/AdminSectionClusterReportsPage'),
);
const AdminSectionClusterOrganizationsPage = lazy(
  () => import('@pages/AdminSection/AdminSectionClusterOrganizationsPage'),
);

export default function AdminSectionRoutes() {
  const { systemRole } = useSelector(userSelector);

  if (!systemRole) {
    return <Navigate replace to={PATH.HOME} />;
  }

  return (
    <Routes>
      <Route element={<AdminSectionLayout />}>
        <Route index element={withSuspense(AdminSectionUsersPage)} />

        <Route path="users" element={withSuspense(AdminSectionUsersPage)} />
        <Route
          path="clusters"
          element={withSuspense(AdminSectionClustersPage)}
        />
        <Route
          path="organizations"
          element={withSuspense(AdminSectionOrganizationsPage)}
        />

        <Route
          path="clusters/:clusterName"
          element={withSuspense(AdminSectionClusterDetailsLayout)}
        >
          <Route
            path=""
            element={
              <Navigate replace to={AdminSection.ClusterDetailsTab.Nodes} />
            }
          />
          <Route
            path={AdminSection.ClusterDetailsTab.Nodes}
            element={withSuspense(AdminSectionClusterNodesPage)}
          />
          <Route
            path={AdminSection.ClusterDetailsTab.Resources}
            element={withSuspense(AdminSectionClusterResourcesPage)}
          />
          <Route
            path={AdminSection.ClusterDetailsTab.Reports}
            element={withSuspense(AdminSectionClusterReportsPage)}
          />
          <Route
            path={AdminSection.ClusterDetailsTab.Organizations}
            element={withSuspense(AdminSectionClusterOrganizationsPage)}
          />
        </Route>

        <Route
          path="organizations"
          element={withSuspense(AdminSectionOrganizationsPage)}
        />
      </Route>

      <Route
        path="*"
        element={<Navigate replace to={PATH.ADMIN_SECTION_USERS} />}
      />
    </Routes>
  );
}
